import { EA_INTEGRATION_PHASES, launchDarklyHelper, LD_FEATURE_FLAGS } from '../services/launchDarkly.service'

const { PHASE_2, PHASE_3 } = EA_INTEGRATION_PHASES
const { EA_INTEGRATION } = LD_FEATURE_FLAGS

export const getEaIntegrationEnabledFlag = () => [PHASE_2, PHASE_3].includes(launchDarklyHelper.getLocalFlag(EA_INTEGRATION))
export const getEaPhase3EnabledFlag = () => [PHASE_3].includes(launchDarklyHelper.getLocalFlag(EA_INTEGRATION))
